import template from './employee_employment_listing_report.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class ReportEmployeeEmploymentListingReportViewModel
{
	constructor (page)
	{
		this.page = page;
		this.loader = ko.observable(false);

		this.employee_employment_listing_report = ko.observableArray('');
		this.employee_document_types = ko.observableArray('');
		this.current_department_id = ko.observable();
		this.selected_department = ko.observable();
		this.show_hint = ko.observable(true);

		this.selected_department.subscribe((newValue) => {
			this.employee_employment_listing_report([]);
			this.show_hint(true);

			if (newValue != null)
				this.current_department_id(newValue.department_id);
			else
				this.current_department_id(null);
		});
	};
}

class ReportEmployeeEmploymentListing 
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new ReportEmployeeEmploymentListingReportViewModel(this);
	}

	async init()
	{
		// check access to page
		if (await Utils.redirectOnAccessDenied('EmployeeEmploymentListingReport'))
			return;

		document.title = tr('Employee Employment Listing Report');
		window.current_page_title(tr('Employee Employment Listing Report'));

		let res = await Grape.fetches.getJSON('/api/record', { 
			table: 'employee_document_types',
			limit: 1000000,
			sortfield: 'type',
			sortorder: 'ASC'
		});

		if (res)
			this.viewModel.employee_document_types(res.records);
	}

	updateData()
	{
		if (this.viewModel.current_department_id() != null)
			this.update_report_data();
	}

	async update_report_data()
	{
		console.log('Selected department',this.viewModel.selected_department())
		if (this.viewModel.selected_department() === undefined || this.viewModel.selected_department() === null)
		{
			Grape.alerts.alert({
				type: 'warning',
				title: 'Warning',
				message: tr('Please select a department before loading')
			});
			return
		}

		this.viewModel.employee_employment_listing_report('');
		this.viewModel.loader(true);
		
		let res = await Grape.fetches.getJSON('/api/record', {
			schema: 'savanna',
			table: 'v_employee_employment_listing',
			limit: 1000000,
			filter: [{ value: this.viewModel.current_department_id(), op: '=', field: 'department_id' }]
		});

		if (res)
		{
			this.viewModel.employee_employment_listing_report(res.records);
			this.viewModel.loader(false);
			this.viewModel.show_hint(false);
		}
	}

	show_report_help()
	{
		Grape.dialog.open('EmployeeEmploymentListingReportHelp', { 'employee_id': this.bindings.id }, {});
	}

	async downLoadClicked(v, e)
	{
		if (!this.viewModel.employee_employment_listing_report().length)
			return;

		let table = document.getElementById('employee_employment_listing_report');

		// Create a temporary clone of the table to modify
		let temp_table = table.cloneNode(true);

		// Remove the alert rows (no data and hint messages)
		let alert_rows = temp_table.querySelectorAll('.ps-alert-nodata');
		alert_rows.forEach(row => row.remove());

		// Find all listings cells and replace divs with pipe separators
		let listings_cells = temp_table.querySelectorAll('tbody tr td:nth-child(5)');
		listings_cells.forEach(cell => {
			let divs = cell.querySelectorAll('div');
			if (divs.length > 0) {
				let text_parts = [];
				divs.forEach(div => {
					// Get text content and clean up whitespace
					let text = div.textContent.trim().replace(/\s+/g, ' ');
					if (text) {
						text_parts.push(text);
					}
				});
				// Replace cell content with pipe-separated text
				cell.innerHTML = text_parts.join(' | ');
			}
		});

		// Convert the cleaned table to CSV
		let csv_string = await Utils.table_to_csv(temp_table);

		if (csv_string === null || csv_string === undefined || csv_string === '')
			return;

		// Create and trigger download
		let blob = new Blob([csv_string], { type: 'text/csv;charset=utf-8;' });
		let link = document.createElement('a');

		link.href = URL.createObjectURL(blob);
		link.setAttribute('download', 'employee_employment_listing_report.csv');

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

export default {
	route: '[/]report/employee_employment_listing_report',
	page_class: ReportEmployeeEmploymentListing,
	template: template,
	template_filename: 'translation/employee_employment_listing_report'
};
